import React from 'react'
import LgyAlertDialog from 'app/components/util/lgy-alert-dialog/LgyAlertDialog'

const ErrorMessage = () =>
  <div className='lgy-alert-form-error'>
    <LgyAlertDialog type='error' heading='Unable to submit' text='The page was not saved. Please correct the issues found for the particular field(s) noted in red text.' />
  </div>

export default ErrorMessage